import { configureStore } from "@reduxjs/toolkit";
import blogReducer from "./slices/blogSlice";
import contactReducer from "./slices/contactSlice";

const store = configureStore({
  reducer: {
    blogs: blogReducer,
    contact: contactReducer,
  },
});

export default store;
